import React from 'react';
import styled from 'styled-components';

const ButtonStyle = styled.div`
    .button {
        height: 40px;
        text-decoration: none;
        text-align: center;
        color: #ffffff;
        border-radius: 2px;
        display: flex;
        align-items: center;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        margin: 0 6px 8px 0;
        text-transform: capitalize;
        box-sizing: border-box;
       
        img, amp-img {
            height: 17px;
            width: 17px;
                 }

        img {
            margin: 11px 9px 11px 11px;   
        }

        amp-img {
            margin: 0 11px 0 11px;
            
            img {
                margin: 0;    
            }
        }
        span {
            margin: 5px 5px 5px 3px;
        }
    }

    .facebook {
        width: 183px;
        height: 36px;
        background-color: #3d5b97;
    }
        
    .twitter {
        width: 165px;
        height: 36px;
        background-color: #2aa3f0;
    }
        
    .bandsintown {
        width: 205px;
        height: 36px;
        background-color: #00b4b3;
        
        img {
            fill: #000000
        }
    }

    @media (max-width: 700px){
        .item {
            margin-bottom: 9px
        }
    }
`

export default class Button extends React.Component {
   static determineText(type){
        if (type === "bandsintown"){
            return "Track on Bandsintown"
        } 
        return `Share on ${type}`
     }
    render(){
        const {logo, type, shareURL} = this.props
        return (
            <ButtonStyle>
                {/* {console.log("logo", {logo, type})} */}
                <a 
                    target="_blank"
                    className={`button ${type}`} 
                    href={shareURL}>
                    <img 
                        
                        src={logo} 
                        alt=""
                        layout="fixed" 
                    />
                    <span>{Button.determineText(type)}</span>
                </a>
            </ButtonStyle>
        )
    }
}
